import { render, staticRenderFns } from "./SubpageNav2.vue?vue&type=template&id=3b2b4908&scoped=true&"
import script from "./SubpageNav2.vue?vue&type=script&lang=js&"
export * from "./SubpageNav2.vue?vue&type=script&lang=js&"
import style0 from "./SubpageNav2.vue?vue&type=style&index=0&id=3b2b4908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2b4908",
  null
  
)

export default component.exports